// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollDown_wrapper__BOhju","Show":"ScrollDown_Show__JWL8w"};